import React, { useState } from 'react';
import { safeFetch } from './App';
import { motion, AnimatePresence } from 'framer-motion';

export default function ModerationReportButton({ entity_id, entity_type, zone, chatId }) {
    const [showPanel, setShowPanel] = useState(false);
    const [message, setMessage] = useState('');
    const [contact, setContact] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submitReport = async () => {
        if (!message.trim()) {
            alert("אנא הזן סיבת דיווח");
            return;
        }

        try {
            setSubmitting(true);
            const res = await safeFetch('https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/report-entity', chatId, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    entity_id,
                    entity_type,
                    zone,
                    chat_id: chatId,
                    message,
                    contact
                }),
            });

            if (res.ok) {
                setSubmitted(true);
            } else {
                const error = await res.text();
                console.error('Report failed:', error);
                alert('❌ שגיאה בשליחה');
            }
        } catch (err) {
            console.error('❌ Report error:', err);
            alert('❌ שגיאה כללית');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            {/* <button
                onClick={() => setShowPanel(true)}
                className="text-sm font-semibold px-3 py-1 rounded-full bg-danger-100 text-danger-700 border border-danger-100 hover:bg-danger-100 transition"
            >
                🚩 דווח
            </button> */}

            {showPanel && (
                <motion.div
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    className="fixed inset-0 z-[1000] flex items-center justify-center"
                >
                    <div className="bg-white text-black rounded-xl p-6 w-[90%] max-w-sm shadow-xl space-y-4 relative border border-black">
                        <button
                            onClick={() => setShowPanel(false)}
                            className="absolute top-2 left-2 text-danger-600 font-bold"
                        >
                            ✕
                        </button>

                        {submitted ? (
                            <div className="text-center text-success-600 font-bold">
                                ✅ הדיווח נשלח לבדיקה. תודה!
                            </div>
                        ) : (
                            <>
                                <h3 className="text-lg font-bold">דיווח על תוכן</h3>
                                <textarea
                                    rows={3}
                                    placeholder="מה הבעיה בתוכן הזה?"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    className="w-full p-2 border rounded text-sm"
                                />
                                <input
                                    type="text"
                                    placeholder="פרטי קשר (לא חובה)"
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    className="w-full p-2 border rounded text-sm"
                                />
                                <button
                                    onClick={submitReport}
                                    disabled={submitting}
                                    className="w-full bg-danger-600 hover:bg-danger-700 text-white py-2 rounded font-bold text-sm"
                                >
                                    {submitting ? 'שולח...' : 'שלח דיווח'}
                                </button>
                            </>
                        )}
                    </div>
                </motion.div>
            )}

        </>
    );
}
